// extracted by mini-css-extract-plugin
export default {"outerDiv":"FavoriteOrders_outerDiv__B28Ji","innerDiv":"FavoriteOrders_innerDiv__bF+2z"};